import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { rootRoute } from './root.tsx'
import { parsePositiveInt } from './params.ts'

// The internal twin of /iscrizione: a guardian already signed in adds a further child.
// `clubId` carries the club chosen before a sign-in detour through the public wizard.

export interface AddChildSearch {
  readonly clubId?: number
}

export const myParentAddChildRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.myParentAddChild,
  validateSearch: (search: Record<string, unknown>): AddChildSearch => ({
    clubId: parsePositiveInt(search.clubId) ?? undefined,
  }),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['parent'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/my-parent/add-child.tsx')),
})

/** Where a guardian enrols a further child. A constant so no page respells the path. */
export const myParentAddChildLink = { to: NAV_PATHS.myParentAddChild, search: {} } as const
